import { render, staticRenderFns } from "./PoliticsPerson.vue?vue&type=template&id=f4219722"
import script from "./PoliticsPerson.vue?vue&type=script&lang=js"
export * from "./PoliticsPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports